export default class InfoSlider {
	constructor({ elements }) {
		elements.forEach((el) => {
			const closeBtn = el.querySelector('.btn--close');
			const jobboardGridClass = document.querySelectorAll('.jobboard-grid-order');
			closeBtn.addEventListener('click', () => {
				el.classList.add('hidden');
				jobboardGridClass.forEach((classElement) => {
					classElement.classList.remove('jobboard-grid-order');
				});
			});
		});
	}
}
